
export class CustomAuditable {
    public id?: number;
    createdBy = '';
    createdDate = '';
    lastModifiedBy = '';
    lastModifiedDate = '';

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'id', field: 'id', label: '序号'},
            {name: 'createdDate', field: 'createDate', label: '创建日期'},
            {name: 'createdBy', field: 'createdBy', label: '创建人'},
            {name: 'lastModifiedBy', field: 'lastModifiedBy', label: '修改人'},
            {name: 'lastModifiedDate', field: 'lastModifiedDate', label: '最后修改日期'},
        ];
    }
}